import React,{useEffect,useState} from "react";
import AppContainer from "./appcontainer.jsx";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import LoadingPage from "./pages/LoadingPage.jsx";
const AppRouter = () => {
  // const config = "/template/react";
  //"/react/template/"


  const {loading} = useAuth()
  return (
        <>
    <Router basename="/">
      <AppContainer  />
    </Router>
    <LoadingPage loading={loading}></LoadingPage>
    </>
  );
};

export default AppRouter;
